let stripePromise = null

export function loadStripe(key) {
  if (! stripePromise) {
    stripePromise = loadScript(key)
  }

  return stripePromise
}

function loadScript(key) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.setAttribute('src', 'https://js.stripe.com/v3/')
    script.onload = function () {
      if (window.Stripe) {
        resolve(window.Stripe(key))
      } else {
        reject(new Error('Stripe failed to load'))
      }
    }

    document.head.appendChild(script)
  })
}
